import get from "lodash.get";
import commaSeparate from "./commaSeparate";

const pickCommaSeparate = (obj, arr) => commaSeparate(arr.map((item) => get(obj, item)));

export default pickCommaSeparate;
